import React from "react";
import { Box, Flex, HStack, Menu, Portal, Text } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronDown, LogOut } from "lucide-react";
import { logout } from "../../Redux/Action/auth/logoutAction";

const getInitials = (text = "") =>
  String(text)
    .replace(/@.*/, "")
    .split(/[\s._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "A";

export const NavbarMenu = () => {
  const userData = useSelector((state) => state?.Login?.userData);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <Menu.Root positioning={{ placement: "bottom-end" }}>
      <Menu.Trigger asChild>
        <HStack
          as="button"
          type="button"
          gap={2.5}
          pl={1}
          pr={2}
          py={1}
          borderRadius="full"
          border="1px solid"
          borderColor="border.subtle"
          bg="bg.surface"
          cursor="pointer"
          _hover={{ bg: "gray.50", borderColor: "gray.300" }}
          _expanded={{ bg: "gray.50", borderColor: "gray.300" }}
          transition="all 140ms ease"
        >
          <Flex
            w="30px"
            h="30px"
            borderRadius="full"
            bg="brand.600"
            color="white"
            fontSize="xs"
            fontWeight="700"
            align="center"
            justify="center"
          >
            {getInitials(userData?.email)}
          </Flex>
          <Text
            display={{ base: "none", md: "block" }}
            fontSize="sm"
            fontWeight="500"
            color="fg.default"
            maxW="200px"
            lineClamp={1}
          >
            {userData?.email}
          </Text>
          <Box color="fg.subtle" display={{ base: "none", md: "block" }}>
            <ChevronDown size={16} />
          </Box>
        </HStack>
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content
            borderRadius="xl"
            boxShadow="pop"
            bg="bg.surface"
            border="1px solid"
            borderColor="border.subtle"
            minW="240px"
            p={1.5}
          >
            <Box px={3} py={2.5}>
              <Text fontSize="xs" color="fg.subtle">
                Signed in as
              </Text>
              <Text fontSize="sm" fontWeight="600" color="fg.default" lineClamp={1}>
                {userData?.email}
              </Text>
            </Box>

            <Menu.Item
              value="account-no"
              cursor="default"
              _hover={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              display="flex"
              justifyContent="space-between"
              fontSize="sm"
              color="fg.muted"
            >
              Account No.
              <Box fontWeight="600" color="fg.default" fontVariantNumeric="tabular-nums">
                {userData?.accountno}
              </Box>
            </Menu.Item>

            <Box height="1px" bg="border.subtle" my="1.5" />

            <Menu.Item
              value="logout"
              color="red.600"
              _hover={{ bg: "red.50", color: "red.700" }}
              onClick={handleLogout}
              fontWeight="500"
              fontSize="sm"
              cursor="pointer"
              gap={2}
            >
              <LogOut size={15} />
              Logout
            </Menu.Item>
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
